import React, { useMemo } from 'react';
import { Card, Form, Input, Select } from '../../../../components';
import { cidrToNetmask, isValidIP } from '../../../../lib/helpers';
import { IP_TYPE } from '../../../../constants/network';

const IP_TYPE_OPTIONS = [
    { value: IP_TYPE.DHCP, label: 'DHCP' },
    { value: IP_TYPE.STATIC, label: 'Static' },
];

const requiredRule = (message) => ({ required: true, message });

const ipValidator = (message) => ({
    validator: async (_rule, value) => {
        if (value && !isValidIP(value)) {
            throw new Error(message);
        }
    },
});

export const AzureLocalNetworkConfig = ({ network = null, disabled = false, title = 'Network Adapter' }) => {
    const form = Form.useFormInstance();
    const ipType = Form.useWatch('ipType', form) || IP_TYPE.DHCP;
    const isStatic = ipType === IP_TYPE.STATIC;

    const handleIpTypeChange = (value) => {
        const subnet = network?.subnets?.[0];
        if (subnet && value === IP_TYPE.STATIC) {
            const dns = network?.dns_ip || subnet.dns_ip || [];
            const netmask = cidrToNetmask(subnet?.cidr_block);
            const gateway = subnet?.routes?.[0]?.gateway;

            const staticIpFields = {};
            if (netmask && !form.getFieldValue('netmask')) {
                staticIpFields.netmask = netmask;
            }
            if (gateway && !form.getFieldValue('gateway')) {
                staticIpFields.gateway = gateway;
            }
            if (dns[0] && !form.getFieldValue('primaryDns')) {
                staticIpFields.primaryDns = dns[0];
            }
            if (dns[1] && !form.getFieldValue('secondaryDns')) {
                staticIpFields.secondaryDns = dns[1];
            }
            if (Object.keys(staticIpFields).length > 0) {
                form.setFieldsValue(staticIpFields);
            }
        }
    };

    return (
        <Card title={title} size="small" className="network-config-card network-config-card--appliance">
            <Form.Item name="ipType" label="IP Type" initialValue={IP_TYPE.DHCP}>
                <Select
                    onChange={handleIpTypeChange}
                    options={IP_TYPE_OPTIONS}
                    disabled={disabled}
                />
            </Form.Item>
            {isStatic && (
                <>
                    <Form.Item
                        name="ipAddr"
                        label="IP Address"
                        rules={[
                            requiredRule('IP Address is required'),
                            ipValidator('IP Address must be a valid IP address'),
                        ]}
                    >
                        <Input placeholder="Enter IP address" disabled={disabled} />
                    </Form.Item>

                    <Form.Item name="netmask" label="Netmask" rules={[requiredRule('Netmask is required')]}>
                        <Input placeholder="Enter netmask" disabled={disabled} />
                    </Form.Item>

                    <Form.Item
                        name="gateway"
                        label="Gateway"
                        rules={[
                            requiredRule('Gateway is required'),
                            ipValidator('Gateway must be a valid IP address'),
                        ]}
                    >
                        <Input placeholder="Enter gateway" disabled={disabled} />
                    </Form.Item>

                    <Form.Item
                        name="primaryDns"
                        label="Primary DNS"
                        rules={[requiredRule('Primary DNS is required')]}
                    >
                        <Input placeholder="Enter primary DNS" disabled={disabled} />
                    </Form.Item>

                    <Form.Item
                        name="secondaryDns"
                        label="Secondary DNS"
                        rules={[ipValidator('Secondary DNS must be a valid IP address')]}
                    >
                        <Input placeholder="Enter secondary DNS (optional)" disabled={disabled} />
                    </Form.Item>
                </>
            )}
        </Card>
    );
};

